import LoginView from '../components/screens/LoginView';

function LoginPage({ auth }) {
  return (
    <LoginView
      backendUrl={auth.backendUrl}
      loginUrl={auth.loginUrl}
      currentUser={auth.currentUser}
      email={auth.email}
      password={auth.password}
      isSubmittingLogin={auth.isSubmittingLogin}
      loginStatus={auth.loginStatus}
      isFirebaseConfigured={auth.isFirebaseConfigured}
      onEmailChange={auth.setEmail}
      onPasswordChange={auth.setPassword}
      onSubmit={auth.handleLoginSubmit}
      onLogout={auth.handleLogout}
    />
  );
}

export default LoginPage;
